var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "md-layout md-gutter md-alignment-top-center",
          staticStyle: { "padding-bottom": "50px" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-15 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-fab",
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_c("md-icon", [_vm._v("arrow_back")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-70 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "md-card",
                { staticStyle: { width: "100%" } },
                [
                  _c("md-card-header", [
                    _c("div", { staticClass: "md-title" }, [
                      _vm._v("Neuigkeiten")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.loggedIn
                    ? _c("md-card-content", [
                        _vm.news && _vm.news.length > 0
                          ? _c(
                              "div",
                              _vm._l(_vm.news, function(newsitem) {
                                return _c("div", { key: newsitem.hash }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout md-gutter md-alignment-top-center"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "md-layout-item md-size-5 md-medium-size-5 md-small-size-0 md-xsmall-size-0"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-90 md-medium-size-90 md-small-size-100 md-xsmall-size-100"
                                        },
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticStyle: {
                                                "text-align": "right",
                                                "margin-bottom": "50px",
                                                opacity: "0.7"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(newsitem.hash) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(newsitem.greeting.header)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(newsitem.greeting.body)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(newsitem.content, function(
                                            item
                                          ) {
                                            return _c(
                                              "div",
                                              { key: item.header },
                                              [
                                                _c("hr", {
                                                  staticStyle: { height: "1px" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "md-layout md-gutter md-alignment-center-center"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "md-layout-item md-size-30 md-medium-size-30 md-small-size-40 md-xsmall-size-50"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: item.image
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "md-layout-item md-size-70 md-medium-size-70 md-small-size-60 md-xsmall-size-50"
                                                      },
                                                      [
                                                        _c("h4", [
                                                          _vm._v(
                                                            _vm._s(item.header)
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              item.body
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        item.link
                                                          ? _c(
                                                              "p",
                                                              [
                                                                _c(
                                                                  "router-link",
                                                                  {
                                                                    attrs: {
                                                                      to: {
                                                                        name:
                                                                          "BMMenu"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Hier"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " können Sie sich das Video anschauen.\n                        "
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("hr", {
                                            staticClass: "my-4",
                                            staticStyle: { height: "1px" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "h3",
                                            {
                                              staticClass: "mb-2 mt-3 ml-2",
                                              staticStyle: {
                                                "text-align": "left",
                                                opacity: "0.7"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Kontakt\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "contact__wrapper d-flex justify-space-between flex-wrap"
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass: "ma-2",
                                                      attrs: {
                                                        size: "120",
                                                        tile: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          src:
                                                            _vm.newsstatic.andi
                                                              .image
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "ma-2",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.newsstatic.andi
                                                          .contact
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass: "ma-2",
                                                      attrs: {
                                                        size: "120",
                                                        tile: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          src:
                                                            _vm.newsstatic
                                                              .sabine.image
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "ma-2",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.newsstatic.sabine
                                                          .contact
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass: "ma-2",
                                                      attrs: {
                                                        size: "120",
                                                        tile: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          position:
                                                            "top center",
                                                          src:
                                                            _vm.newsstatic.sarah
                                                              .image
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "ma-2",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.newsstatic.sarah
                                                          .contact
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("hr", {
                                            staticStyle: { height: "1px" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout md-gutter md-alignment-top-center",
                                              staticStyle: {
                                                "margin-top": "30px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left",
                                                        "margin-bottom": "50px",
                                                        opacity: "0.7"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Partner\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.sf
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        _vm.newsstatic.dfkismall
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.tuk
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.ita
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("hr", {
                                            staticStyle: { height: "1px" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout md-gutter md-alignment-center-center",
                                              staticStyle: {
                                                "margin-top": "30px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left",
                                                        "margin-bottom": "50px",
                                                        opacity: "0.7"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Förderer\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.md
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.bmwi
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "Was ist Mittelstand-Digital?"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      "\n                        Mittelstand-Digital informiert kleine und mittlere\n                        Unternehmen über die Chancen und Herausforderungen der\n                        Digitalisierung. Die geförderten Kompetenzzentren\n                        helfen mit Expertenwissen, Demonstrationszentren,\n                        Best-Practice-Beispielen sowie Netzwerken, die dem\n                        Erfahrungsaustausch dienen. Das Bundesministerium für\n                        Wirtschaft und Energie ermöglicht die kostenfreie\n                        Nutzung aller Angebote von Mittelstand-Digital.\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("b", [
                                                      _vm._v(
                                                        "Weitere Informationen finden Sie unter\n                          www.mittelstand-digital.de"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Das Mittelstand 4.0-Kompetenzzentrum\n                        Kaiserslautern gehört zu Mittelstand-Digital. Mit\n                        Mittelstand- Digital unterstützt das Bundesministerium\n                        für Wirtschaft und Energie die Digitalisierung in\n                        kleinen und mittleren Unternehmen und dem Handwerk.\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "http://www.kompetenzzentrum-kaiserslautern.digital"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "www.kompetenzzentrum-kaiserslautern.digital"
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("hr", {
                                            staticStyle: { height: "1px" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout md-gutter md-alignment-center-center",
                                              staticStyle: {
                                                "margin-top": "30px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-90 md-medium-size-100 md-small-size-100 md-xsmall-size-100",
                                                  staticStyle: {
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      "\n                        Werner. Netzwerk für Innovation.\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "https://werner.dfki.de"
                                                        }
                                                      },
                                                      [_vm._v("WERNER")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Mittelstand 4.0-Kompetenzzentrum Kaiserslautern\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Institut für Wirtschaftsinformatik "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "im\n                        Deutschen Forschungszentrum für Künstliche Intelligenz\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Stuhlsatzenhausweg 3, 66123 Saarbrücken\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Verantwortlich: Andreas Emrich "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Wir\n                        garantieren Ihnen, dass wir Ihre Daten vertraulich\n                        behandeln und nicht an Dritte weitergeben.\n                      "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "md-layout-item md-size-5 md-medium-size-5 md-small-size-0 md-xsmall-size-0"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("hr", { staticStyle: { height: "1px" } }),
                                  _vm._v(" "),
                                  _c("hr", { staticStyle: { height: "1px" } })
                                ])
                              }),
                              0
                            )
                          : _c("div", [_vm._v("Keine Einträge vorhanden")])
                      ])
                    : _c("md-card-content", [
                        _c("div", [
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                "\n                Sie wollen auf dem Laufenden bleiben?\n                "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#9a2a28",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.newsletter = true
                                    }
                                  }
                                },
                                [_vm._v("Hier")]
                              ),
                              _vm._v(
                                "\n                können Sie sich für die WERNER Mailingliste anmelden.\n              "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.news && _vm.news.length > 0
                          ? _c(
                              "div",
                              _vm._l(_vm.news, function(newsitem) {
                                return _c("div", { key: newsitem.hash }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout md-gutter md-alignment-top-center"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "md-layout-item md-size-5 md-medium-size-5 md-small-size-0 md-xsmall-size-0"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-90 md-medium-size-90 md-small-size-100 md-xsmall-size-100"
                                        },
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticStyle: {
                                                "text-align": "right",
                                                "margin-bottom": "50px",
                                                opacity: "0.7"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(newsitem.hash) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(newsitem.greeting.header)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(newsitem.greeting.body)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(newsitem.content, function(
                                            item
                                          ) {
                                            return _c(
                                              "div",
                                              { key: item.header },
                                              [
                                                _c("hr", {
                                                  staticStyle: { height: "1px" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "md-layout md-gutter md-alignment-center-center"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "md-layout-item md-size-30 md-medium-size-30 md-small-size-40 md-xsmall-size-50"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: item.image
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "md-layout-item md-size-70 md-medium-size-70 md-small-size-60 md-xsmall-size-50"
                                                      },
                                                      [
                                                        _c("h4", [
                                                          _vm._v(
                                                            _vm._s(item.header)
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              item.body
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        item.link
                                                          ? _c(
                                                              "p",
                                                              [
                                                                _c(
                                                                  "router-link",
                                                                  {
                                                                    attrs: {
                                                                      to: {
                                                                        name:
                                                                          "BMHelp"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Hier"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " können Sie sich das Video anschauen.\n                        "
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("hr", {
                                            staticClass: "my-4",
                                            staticStyle: { height: "1px" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "h3",
                                            {
                                              staticClass: "mb-2 mt-3 ml-2",
                                              staticStyle: {
                                                "text-align": "left",
                                                opacity: "0.7"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Kontakt\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "contact__wrapper d-flex justify-space-between flex-wrap"
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass: "ma-2",
                                                      attrs: {
                                                        size: "120",
                                                        tile: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          src:
                                                            _vm.newsstatic.andi
                                                              .image
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "ma-2",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.newsstatic.andi
                                                          .contact
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass: "ma-2",
                                                      attrs: {
                                                        size: "120",
                                                        tile: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          src:
                                                            _vm.newsstatic
                                                              .sabine.image
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "ma-2",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.newsstatic.sabine
                                                          .contact
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass: "ma-2",
                                                      attrs: {
                                                        size: "120",
                                                        tile: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          position:
                                                            "top center",
                                                          src:
                                                            _vm.newsstatic.sarah
                                                              .image
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "ma-2",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.newsstatic.sarah
                                                          .contact
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("hr", {
                                            staticStyle: { height: "1px" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout md-gutter md-alignment-top-center",
                                              staticStyle: {
                                                "margin-top": "30px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left",
                                                        "margin-bottom": "50px",
                                                        opacity: "0.7"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Partner\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.sf
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        _vm.newsstatic.dfkismall
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.tuk
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.ita
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("hr", {
                                            staticStyle: { height: "1px" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout md-gutter md-alignment-center-center",
                                              staticStyle: {
                                                "margin-top": "30px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left",
                                                        "margin-bottom": "50px",
                                                        opacity: "0.7"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Förderer\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.md
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-50"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.newsstatic.bmwi
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "Was ist Mittelstand-Digital?"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      "\n                        Mittelstand-Digital informiert kleine und mittlere\n                        Unternehmen über die Chancen und Herausforderungen der\n                        Digitalisierung. Die geförderten Kompetenzzentren\n                        helfen mit Expertenwissen, Demonstrationszentren,\n                        Best-Practice-Beispielen sowie Netzwerken, die dem\n                        Erfahrungsaustausch dienen. Das Bundesministerium für\n                        Wirtschaft und Energie ermöglicht die kostenfreie\n                        Nutzung aller Angebote von Mittelstand-Digital.\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("b", [
                                                      _vm._v(
                                                        "Weitere Informationen finden Sie unter\n                          www.mittelstand-digital.de"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Das Mittelstand 4.0-Kompetenzzentrum\n                        Kaiserslautern gehört zu Mittelstand-Digital. Mit\n                        Mittelstand- Digital unterstützt das Bundesministerium\n                        für Wirtschaft und Energie die Digitalisierung in\n                        kleinen und mittleren Unternehmen und dem Handwerk.\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "http://www.kompetenzzentrum-kaiserslautern.digital"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "www.kompetenzzentrum-kaiserslautern.digital"
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("hr", {
                                            staticStyle: { height: "1px" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout md-gutter md-alignment-center-center",
                                              staticStyle: {
                                                "margin-top": "30px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout-item md-size-90 md-medium-size-100 md-small-size-100 md-xsmall-size-100",
                                                  staticStyle: {
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      "\n                        Werner. Netzwerk für Innovation.\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "https://werner.dfki.de"
                                                        }
                                                      },
                                                      [_vm._v("WERNER")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Mittelstand 4.0-Kompetenzzentrum Kaiserslautern\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Institut für Wirtschaftsinformatik "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "am\n                        Deutschen Forschungszentrum für künstliche Intelligenz\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Stuhlsatzenhausweg 3, 66123 Saarbrücken\n                        "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Verantwortlich: Andreas Emrich "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "Wir\n                        garantieren Ihnen, dass wir Ihre Daten vertraulich\n                        behandeln und nicht an Dritte weitergeben.\n                      "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "md-layout-item md-size-5 md-medium-size-5 md-small-size-0 md-xsmall-size-0"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("hr", { staticStyle: { height: "1px" } }),
                                  _vm._v(" "),
                                  _c("hr", { staticStyle: { height: "1px" } })
                                ])
                              }),
                              0
                            )
                          : _c("div", [_vm._v("Keine Einträge vorhanden")])
                      ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "md-layout-item md-size-15 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.newsletter },
          on: {
            "update:mdActive": function($event) {
              _vm.newsletter = $event
            },
            "update:md-active": function($event) {
              _vm.newsletter = $event
            }
          }
        },
        [
          _c(
            "form",
            {
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validateData.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _c("div", { staticClass: "md-title" }, [
                      _vm._v("Anmeldung zu unserer Mailingliste")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("md-card-content", [
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("firstname") },
                            [
                              _c("label", { attrs: { for: "first-name" } }, [
                                _vm._v("Vorname")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "first-name",
                                  id: "first-name",
                                  autocomplete: "given-name",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.firstname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "firstname", $$v)
                                  },
                                  expression: "form.firstname"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.firstname.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Der Vorname ist notwendig")
                                  ])
                                : !_vm.$v.form.firstname.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültiger Vorname")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("lastname") },
                            [
                              _c("label", { attrs: { for: "last-name" } }, [
                                _vm._v("Nachname")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "last-name",
                                  id: "last-name",
                                  autocomplete: "family-name",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.lastname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "lastname", $$v)
                                  },
                                  expression: "form.lastname"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.lastname.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Der Nachname ist notwendig")
                                  ])
                                : !_vm.$v.form.lastname.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültiger Nachname")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("gender") },
                            [
                              _c("label", { attrs: { for: "gender" } }, [
                                _vm._v("Geschlecht")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-select",
                                {
                                  attrs: {
                                    name: "gender",
                                    "md-dense": "",
                                    disabled: _vm.sending
                                  },
                                  model: {
                                    value: _vm.form.gender,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "gender", $$v)
                                    },
                                    expression: "form.gender"
                                  }
                                },
                                [
                                  _c("md-option", { attrs: { value: "m" } }, [
                                    _vm._v("männlich")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "f" } }, [
                                    _vm._v("weiblich")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "d" } }, [
                                    _vm._v("divers")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v("Das Geschlecht ist notwendig")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "md-layout-item md-small-size-100"
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("email") },
                            [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v("Email")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  type: "email",
                                  name: "email",
                                  id: "email",
                                  autocomplete: "email",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.email.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Die Mail-Adresse wird benötigt")
                                  ])
                                : !_vm.$v.form.email.email
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültige Mail-Adresse")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-actions",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-accent",
                          on: {
                            click: function($event) {
                              _vm.newsletter = false
                            }
                          }
                        },
                        [_vm._v("Abbrechen")]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: { type: "submit" }
                        },
                        [_vm._v("Anmelden")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2094a952", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2094a952","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/news/News.vue
// module id = null
// module chunks = 